import { getSectionHeadingPath } from '@utils/apiFunctions.js';
import httpClient from '@utils/httpClient.js';
import { pathTypes } from '@utils/sectionEnums.js';

export function updateContactApiCall({
  id,
  isPathDesign,
  userId,

  view,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,

  itemShadow,
  itemShadowColor,
  itemShape,
  itemOpacity,
  itemBorder,
  itemBorderColor,

  buttonTitle,
  buttonOpacity,
  buttonBackgroundColor,
  buttonTextColor,
  buttonBorder,
  buttonBorderColor,
  buttonShadow,
  buttonShadowColor,
  buttonShape,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.contacts, isPathDesign), {
    id,
    profileId: userId,
    view,
    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,

    itemShadow,
    itemShadowColor,
    itemShape,
    itemOpacity,
    itemBorder,
    itemBorderColor,

    buttonTitle,
    buttonOpacity,
    buttonBackgroundColor,
    buttonTextColor,
    buttonBorder,
    buttonBorderColor,
    buttonShadow,
    buttonShadowColor,
    buttonShape,
  });
}
